import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, ButtonLoader } from '../../../core';
import { UsuarioAlteraSenha } from './usuario-altera-senha';
import { UsuarioAlteraSenhaHttpService } from './services';

@Component({
    selector: 'sgt-usuario-altera-senha-modal',
    templateUrl: './usuario-altera-senha-modal.component.html'
})
export class UsuarioAlteraSenhaModalComponent implements OnInit {
    @Input() idModal: string;
    elModal: any;

    @ViewChild('form') form: NgForm;
    entity = new UsuarioAlteraSenha(null);
    nomeUsuario: string;

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private usuarioAlteraSenhaHttpService: UsuarioAlteraSenhaHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#novaSenha').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    open(idUsuario: number, nomeUsuario?: string) {
        this.entity = new UsuarioAlteraSenha(idUsuario);
        this.nomeUsuario = nomeUsuario;
        this.form.resetForm();

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Altera a senha do usuário */
    alterar() {
        const btnAlterarSenha = new ButtonLoader('#btnAlterarSenha');
        btnAlterarSenha.loading('Alterando');
        this.usuarioAlteraSenhaHttpService.alterarSenha(this.entity)
            .subscribe(
                response => {
                    this.messageService.success('', response);
                    btnAlterarSenha.reset();
                    this.close();
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao alterar a senha', error);
                    btnAlterarSenha.reset();
                }
            );
    }
}
